// extracted by mini-css-extract-plugin
export default {"container":"CheckBox_container__gziJ7","checkbox":"CheckBox_checkbox__BsrCB","iconspan":"CheckBox_iconspan__SWjFd"};